import React from 'react';

export default function SiteFooter() {
  return <footer style={styles.footer}>
    <span>&copy; {new Date().getFullYear()} Malluland</span>
    <div style={styles.footerLinks}>
      <a href="/privacy" style={styles.footerLink}>Privacy Policy</a>
      <a href="/terms" style={styles.footerLink}>Terms of Service</a>
      <a href="/contact" style={styles.footerLink}>Contact</a>
    </div>
    <span>What&rsquo;s on in Kerala.</span>
  </footer>;
}

const styles = {
  footer: { width: '100%', boxSizing: 'border-box', borderTop: '1px solid #ddd', maxWidth: 1180, margin: '0 auto', padding: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, color: '#555', fontSize: '0.82rem' },
  footerLinks: { display: 'flex', gap: 18, flexWrap: 'wrap' },
  footerLink: { color: '#555', textDecoration: 'none' },
};
